/**
 * Mass percent: the share each component contributes to a whole.
 *
 *   mass percent of A = (mass of A / total mass) × 100
 *
 * The same arithmetic serves a compound (each element's mass in one mole of it, the
 * "percent composition" of a formula) and a mixture or solution (the weighed masses of
 * its components).
 */

export interface ShareInput {
  label: string;
  mass: number;
}

export interface ShareRow extends ShareInput {
  /** 0–1 */
  fraction: number;
  /** 0–100 */
  percent: number;
}

export interface Shares {
  total: number;
  rows: ShareRow[];
}

/** Null unless every mass is finite and nonnegative and the total is greater than zero. */
export function sharesOf(items: readonly ShareInput[]): Shares | null {
  if (items.some((item) => !(Number.isFinite(item.mass) && item.mass >= 0))) {
    return null;
  }
  const total = items.reduce((sum, item) => sum + item.mass, 0);
  if (!(total > 0)) {
    return null;
  }
  return {
    total,
    rows: items.map((item) => ({
      ...item,
      fraction: item.mass / total,
      percent: (item.mass / total) * 100,
    })),
  };
}
